import { Button, CircularProgress, IconButton, InputAdornment, TextField, Theme, createStyles } from "@mui/material";
import { DrawerContainer } from "../../shared/drawer/DrawerContainer";
import { makeStyles } from '@mui/styles';

import { BrokerComponent } from "../broker/BrokerComponent";
import { PricingContainer } from "../pricing/PricingContainer";
import { useSelector } from "react-redux";
import { BrokerContainer } from "../broker/BrokerContainer";
import { useState } from "react";


const useStyles: any = makeStyles((theme: Theme) => ({
  // root: {
  //   margin: 0,
  // },
  mainContainer: {
    boxSizing: 'border-box',
    width: '100%',
    padding: '0 0 0 65px',
    height: '100%'
  },
}))

export const MainWrapperComponent = () => {
  const classes = useStyles();

  const initialSubComs = [
    { id: 1, topic: "" },
    { id: 2, topic: "" },
    { id: 3, topic: "" },
  ];
  const initialSubscribePriceScreenData = [
    { id: 'NORTH_AMERICA_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/us/nam/51001", topicData : {} },
		{ id: 'NORTH_AMERICA_APPLE', topic: "acme/retail/shopfloor/price/updated/v1/us/nam/51002", topicData : {} },
		{ id: 'EMEA_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/uk/emea/51001" , topicData : {}},
		{ id: 'EMEA_BELGIAN_APPLE', topic: "acme/retail/shopfloor/price/updated/v1/uk/emea/51002", topicData : {} },
		{ id: 'APJ_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/jp/apj/51001" , topicData : {}},
		{ id: 'APJ_AAPLE', topic: "acme/retail/shopfloor/price/updated/v1/jp/apj/51002" , topicData : {}},
  ];
  const [subComs, setSubComs] = useState(initialSubComs);
  const [subscribePriceScreenData, setSubscribePriceScreenData] = useState(initialSubscribePriceScreenData);
  const currentSection = useSelector((state: any) => {
    return state.currentSection.currentSection;
  });

  const renderScreen = (sectionName: string) => {
    switch (currentSection) {
      case 'broker': return <BrokerContainer />
      case 'pricing': return <PricingContainer 
      setSubComs={setSubComs} 
      subComs={subComs}
      subscribePriceScreenData={subscribePriceScreenData}
      setSubscribePriceScreenData={setSubscribePriceScreenData}
      />
    }
  }

  return (
    <div className={classes.root}>
      <DrawerContainer
      />
      <main className={classes.mainContainer}>
        {renderScreen(currentSection)}
      </main>
    </div>
  );
}